import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Form, Button, Card } from 'react-bootstrap';
import axios from 'axios';
import MessageBox from '../components/MessageBox';

export default function ResetPasswordScreen() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submitHandler = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    try {
      const { data } = await axios.post(`/api/users/reset-password/${token}`, { password });
      setMessage(data.message);
      setError('');
      setTimeout(() => navigate('/signin'), 2000);
    } catch (err) {
      setError(
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
      );
      setMessage('');
    }
  };

  return (
    <Card className="mx-auto my-5" style={{ maxWidth: '400px' }}>
      <Card.Body>
        <Helmet>
          <title>Reset Password</title>
        </Helmet>
        <h2 className="mb-3">Reset Password</h2>
        {message && <MessageBox variant="success">{message}</MessageBox>}
        {error && <MessageBox variant="danger">{error}</MessageBox>}
        <Form onSubmit={submitHandler}>
          <Form.Group className="mb-3" controlId="password">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirm">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </Form.Group>
          <div className="d-grid">
            <Button type="submit" variant="primary">
              Reset Password
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}